import type { IPlanSummaryProductConstructorParams } from "@services/sdk/interfaces";
import type { ID } from "@services/sdk/types";
import { map } from "ramda";

class PlanSummaryProduct {
	public static ConstructList(
		arrParams: Array<IPlanSummaryProductConstructorParams>,
	): Array<PlanSummaryProduct> {
		return map(PlanSummaryProduct.Construct)(arrParams);
	}

	public static Construct(
		params: IPlanSummaryProductConstructorParams,
	): PlanSummaryProduct {
		return new PlanSummaryProduct(params);
	}

	responseData: IPlanSummaryProductConstructorParams;

	constructor(params: IPlanSummaryProductConstructorParams) {
		this.responseData = params;
	}

	get id(): ID {
		return this.responseData.id;
	}

	get name(): string {
		return this.responseData.name;
	}

	get iconRef(): string {
		if (
			!this.responseData.appUserData ||
			!this.responseData.appUserData.iconRef
		) {
			return "felix";
		}

		return this.responseData.appUserData.iconRef;
	}

	get type(): string {
		return this.responseData.type;
	}

	get originalPrice(): number {
		return this.responseData.price;
	}

	get discountedPrice(): number {
		return this.responseData.discountedPrice;
	}
}

export default PlanSummaryProduct;
